"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeFormMetadataParams = deserializeFormMetadataParams;
exports.serializeFormMetadataParams = serializeFormMetadataParams;
var _utils = require("../../utils");
var _formMetadataParams = require("./formMetadataParams.legacy");
/**
 * Deserializes a query string or parsed query object to FormMetadataParams.
 * Handles type coercion (string → boolean/number) via Zod schema.
 */
function deserializeFormMetadataParams(query) {
  const parsed = (0, _utils.parseQuery)(query);
  return _formMetadataParams.legacyFormMetadataParamsSchema.parse(parsed);
}

/**
 * Serializes FormMetadataParams to a query string.
 * Uses dot notation for nested objects (e.g., overrides.locale=en).
 */
function serializeFormMetadataParams(params) {
  return (0, _utils.serializeQuery)(params);
}